import React from 'react';
import { NEIS_DEFAULT_URL, NEIS_EXTENSION_STORE_URL } from '../../appMeta';
import { useNeisExtension } from '../../hooks/useNeisExtension';

/** 주간학습 안내 › NEIS 반별시간표 ON 일 때: 나이스 시간표 도우미(확장) 설치 / 나이스 열기 */
export default function NeisExtensionButton() {
  const ext = useNeisExtension(true);
  const [guideOpen, setGuideOpen] = React.useState(false);
  const wrapRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (!guideOpen) return undefined;
    const onDown = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setGuideOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setGuideOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [guideOpen]);

  if (ext.status === 'checking') return null;

  if (ext.status === 'installed') {
    const url = ext.neisOrigin ? `${ext.neisOrigin}/` : NEIS_DEFAULT_URL;
    return (
      <div className="cp-neis-ext-wrap" data-neis-ext="installed">
        <button
          type="button"
          className="cp-neis-ext-btn"
          onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
          title={`${url} 를 새 탭으로 엽니다. 반별시간표 화면에서 오른쪽 아래 CP 버튼을 누르세요.`}
        >
          나이스 열기
        </button>
        {ext.version ? <span className="cp-neis-ext-version">도우미 v{ext.version}</span> : null}
      </div>
    );
  }

  const storeUrl = NEIS_EXTENSION_STORE_URL.trim();
  return (
    <div className="cp-neis-ext-wrap" data-neis-ext="absent" ref={wrapRef}>
      <button
        type="button"
        className="cp-neis-ext-btn"
        aria-expanded={storeUrl ? undefined : guideOpen}
        onClick={() => {
          if (storeUrl) window.open(storeUrl, '_blank', 'noopener,noreferrer');
          else setGuideOpen((v) => !v);
        }}
        title="이 시간표를 나이스 반별시간표에 자동으로 입력해 주는 Chrome 확장 프로그램"
      >
        나이스 시간표 도우미 설치하기
      </button>
      {guideOpen && !storeUrl ? (
        <div className="cp-neis-ext-guide" role="dialog" aria-label="나이스 시간표 도우미 설치 안내">
          <div className="cp-neis-ext-guide-title">Chrome 웹 스토어 등록을 준비 중이에요.</div>
          <div className="cp-neis-ext-guide-body">
            그동안은 받은 zip 파일로 직접 설치할 수 있어요.
            <ol>
              <li>zip 압축을 풀어 <b>neis-timetable</b> 폴더를 둡니다.</li>
              <li>
                Chrome 주소창에 <code>chrome://extensions</code> → 오른쪽 위 <b>개발자 모드</b> 켜기
              </li>
              <li>
                <b>압축해제된 확장 프로그램을 로드합니다</b> → 그 폴더 선택
              </li>
              <li>이 페이지를 새로고침하면 ‘나이스 열기’ 버튼으로 바뀌어요.</li>
            </ol>
          </div>
          <button type="button" className="cp-neis-ext-guide-close" onClick={() => setGuideOpen(false)}>
            닫기
          </button>
        </div>
      ) : null}
    </div>
  );
}
